export default {
  talepKanallari: [
    { value: 1, text: 'Kurumsal Web Sayfası' },
    { value: 2, text: 'Fax' },
    { value: 3, text: 'Posta' },
    { value: 4, text: 'Şikayet Siteleri' },
    { value: 5, text: 'Diğer' },
    { value: 6, text: 'Web' },
    { value: 7, text: 'Sosyal Medya' },
    { value: 8, text: 'BDDK' },
    { value: 9, text: 'CIMER' },
    { value: 10, text: 'SEDDK' },
    { value: 11, text: 'Çağrı Merkezi' },
  ],
  talepEdenTurleri: [
    { value: 1, text: 'Mağdur' },
    { value: 2, text: 'Sigortalı' },
    { value: 3, text: 'Sigorta Ettiren' },
    { value: 4, text: 'Diğer' },
  ],
  talepTurleri: [
    { value: 1, text: 'Talep' },
    { value: 2, text: 'Şikayet' },
  ],
  talepSonuclari: [
    { value: 1, text: 'Haksız' },
    { value: 2, text: 'Haklı' },
    { value: 3, text: 'Vazgeçme' },
  ],
  geriDonusKaynaklari: [
    { value: 1, text: 'SMS' },
    { value: 2, text: 'Telefon' },
    { value: 3, text: 'EPosta' },
    { value: 4, text: 'Diğer' },
  ]
};
